import Hero from "src/components/elements/Hero/Hero";
import Schedule from "src/components/elements/Schedule/Schedule";

const Home = () => {
  return (
    <>
      <Hero />
      <section className="section section--white-bg">
        <div className="container">
          <div className="schedule-wrapper">
            <div className="columns">
              <div className="column is-10 is-offset-1">
                <div className="has-text-centered">
                  <h3 className="emphasis">
                    Autumn Term<br/>
                    Monday 7th September - Wednesday 7th October<br/>
                    No classes week beginning 12th October<br/>
                    Classes resume for 1 week beginning 19th October<br/>
                    No classes week beginning 26th October<br/>
                    Monday 2nd November - Wednesday 16th December<br/>
                    <br/>
                    Spring Term starts 4th January 2027
                  </h3>
                </div>
              </div>
            </div>
            <div className="columns">
              <div className="column is-6">
                <Schedule
                  day="Monday"
                  items={['7pm Westend Workout', '8pm Fitsteps', 'Followed by Fitsteps Tone']}
                  animation="fade-right"
                />
              </div>
            </div>
            <div className="columns">
              <div className="column is-offset-6 is-6">
                <Schedule
                  className="schedule--right"
                  day="Tuesday"
                  items={['8pm Intermediate Tap', 'Followed by Advance Tap']}
                  animation="fade-left"
                />
              </div>
            </div>
            <div className="columns">
              <div className="column is-6">
                <Schedule
                  day="Wednesday"
                  className="schedule--last"
                  items={['8pm Mixed Level Ballet', 'Followed by Pointe at 8.45pm']}
                  animation="fade-right"
                />
              </div>
            </div>
          </div>
          <div className="columns is-multiline">
            <div className="column is-12">
              <h4 className="title is-4">Finding us and getting in touch</h4>
              <p>
                <strong>Mondays &amp; Wednesdays</strong><br/>
                Our Lady School<br/>
                Old Hale Way<br/>
                Hitchin<br/>
                SG5 1XT
              </p>
              <br/>
              <p>
                <strong>Tuesdays</strong><br/>
                Tilehouse Street Baptist Church,<br/>
                Upper Floor School Rooms,<br/>
                Upper Tilehouse St,<br/>
                Hitchin
                <br/>
                SG5 2EE
              </p>
              <br/>
              <p>
                Email - <a href="mailto:info@jsdanceacademy.co.uk">info@jsdanceacademy.co.uk</a><br/>
                Facebook - <a href="https://www.facebook.com/JS-Dance-Academy-223523381032449" target="_blank" rel="noreferrer">JS Dance Academy</a>
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;